import FixedRewardCalculationTypeEditor from "../../../pages/actionModules/ActionModuleEditor/RewardCalculationEditor/FixedRewardCalculationTypeEditor";
import { RewardCalculationTypeDefinition } from "../actionModule";
import { RewardCalculationTypeEditorProps } from "../editor/rewardCalculationTypeEditorTypes";
import { BaseRewardCalculationType, isBaseRewardCalculationTypeModel, RewardCalculationType } from "./rewardCalculationType";

export interface FixedRewardCalculationTypeModel extends BaseRewardCalculationType {
    reward: number;
};

export function isFixedRewardCalculationTypeModel(value: unknown): value is FixedRewardCalculationTypeModel {
    return (
        isBaseRewardCalculationTypeModel(value) &&
        value.type === RewardCalculationType.FixedRewardCalculationType &&
        "reward" in value &&
        typeof (value as FixedRewardCalculationTypeModel).reward === "number"
    );
}

export const FixedRewardCalculationType: RewardCalculationTypeDefinition = {
    name: "actionModules.rewardCalculationType.fixed.name",
    defaultValue: {
        reward: 10,
    },
    type: RewardCalculationType.FixedRewardCalculationType,
    editor: (props: RewardCalculationTypeEditorProps) => <FixedRewardCalculationTypeEditor {...props} />
};